<script>
import {
    modalState, hideModal
} from '@app/store/modalStore.svelte.js';
import {
    timingAndSyncSettingsState
} from '@app/store/timingAndSyncSettingsStore.svelte.js';
import * as m from "@app/paraglide/messages.js";

function updateShortcut(e, name){
    e.preventDefault();
    
    let keyCmd = [];
    if (e.shiftKey) {
        keyCmd.push("Shift");
    }

    if (e.ctrlKey) {
        keyCmd.push("Ctrl");
    }

    if (e.altKey) {
        keyCmd.push("Alt");
    }

    if (e.metaKey) {
        keyCmd.push("Meta(CMD)");
    }

    keyCmd.push(e.code || e.key);
    keyCmd = keyCmd.join("+");

    //Check other shortcuts to see if they have the same key command, and then remove it
    Object.keys(timingAndSyncSettingsState.shortcuts).forEach((key) => {
        if (timingAndSyncSettingsState.shortcuts[key] === keyCmd){
            timingAndSyncSettingsState.shortcuts[key] = "";
        }
    });

    timingAndSyncSettingsState.shortcuts[name] = keyCmd;

    saveSettingsToLocalStorage();
}

function saveSettingsToLocalStorage(){
    localStorage.setItem("cc-timing-and-sync-settings", JSON.stringify(timingAndSyncSettingsState));
}

function saveSettings(){
    saveSettingsToLocalStorage();
    hideModal();
}
</script>

<div class="modal fade {modalState.selected === 'timingAndSyncSettings' ? 'show d-block' : ''}" role="dialog" aria-labelledby="timingSyncTitle" aria-modal="true" tabindex="-1" id="TimingAndSyncModal">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="timingSyncTitle">{m.timing_sync_settings_title()}</h4>
                <button type="button" class="btn-close" aria-label={m.timing_sync_settings_close_label()} onclick={hideModal}></button>
            </div>
            <div class="modal-body">
                <div class="modal-body">
                    <form>
                        <p class="lead text-warning mb-2" id="timingModeLabel">{m.timing_sync_mode_label()}</p>
                        <div class="mb-3">
                            <select class="form-select form-select-sm" id="timingModeSelect" 
                                bind:value={timingAndSyncSettingsState.timingMode}
                                aria-labelledby="timingModeLabel">
                                <option value="long">{m.timing_sync_mode_long_press()}</option>
                                <option value="dual">{m.timing_sync_mode_dual_key()}</option>
                            </select>
                        </div>
                        <p class="lead text-warning mb-2" id="compensationLabel">{m.timing_sync_compensation_label()}</p>
                        <div class="row">
                            <div class="col">
                                <div class="mb-3">
                                    <input class="form-control form-control-sm" type="number" 
                                        id="compensationInput"
                                        min="0" step="1" 
                                        placeholder={m.timing_sync_compensation_placeholder()} 
                                        bind:value={timingAndSyncSettingsState.compensation}
                                        aria-labelledby="compensationLabel">
                                </div>
                            </div>
                            <div class="col">
                                <div class="mb-3">
                                    <div class="form-check form-switch">
                                        <input class="form-check-input" type="checkbox" id="startTimeOnlyCheckbox" 
                                            bind:checked={timingAndSyncSettingsState.startTimeOnly}
                                            aria-label={m.timing_sync_start_time_only_aria()}>
                                        <label class="form-check-label" for="startTimeOnlyCheckbox">{m.timing_sync_start_time_only_label()}</label>
                                    </div>
                                </div>
                            </div>
                        </div>                        
                    </form>
                    <p class="lead text-warning mb-2" id="shortcutsLabel">{m.timing_sync_shortcuts_label()}</p>
                    <div class="row">
                        <div class="col">
                            <div class="table-responsive">
                                <table class="table" aria-labelledby="shortcutsLabel">
                                    <tbody>
                                        <tr>
                                            <td>{m.timing_sync_show_event_label()}</td>
                                            <td>
                                                <input class="form-control" type="text" 
                                                    id="showEventShortcut"
                                                    aria-label={m.timing_sync_show_event_aria()}
                                                    onkeydown={(e) => updateShortcut(e, 'showEvent')}
                                                    onfocus={(e) => e.target.select()}
                                                    value={timingAndSyncSettingsState.shortcuts.showEvent || ""} />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>{m.timing_sync_hide_event_label()}</td>
                                            <td>
                                                <input class="form-control" type="text"
                                                    id="hideEventShortcut" 
                                                    aria-label={m.timing_sync_hide_event_aria()}
                                                    onkeydown={(e) => updateShortcut(e, 'hideEvent')}
                                                    onfocus={(e) => e.target.select()}
                                                    value={timingAndSyncSettingsState.shortcuts.hideEvent || ""} />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <p class="text-danger small" role="alert">{m.timing_sync_modifier_hint()}</p>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-primary" type="button" id="saveSettingsBtn" aria-label={m.timing_sync_save_label()} onclick={saveSettings}>{m.timing_sync_save_label()}</button>
                </div>
            </div>
        </div>
    </div>
</div>
